import { combineReducers } from 'redux'
import { AlertReducer } from './AlertReducer'
import ComponentCallsReducer from './ComponentCallsReducer'
import { PageLoadingReducer } from './PageLoadingReducer'
import CardStateReduer from './CardStateReducer'

const appReducer = combineReducers({
    alerts: AlertReducer,
    pageLoadingState: PageLoadingReducer,
    customerData: ComponentCallsReducer,
    cardData: CardStateReduer,
})

const RootReducer = (state, action) => {
    if (action.type === 'CLEAR_STORE') return appReducer(undefined, action)
    return appReducer(state, action)
}

export default RootReducer
